// components/ProductsSection/ProductsSection.jsx
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { FaClock, FaSignal, FaBook, FaLaptop, FaFileAlt, FaPenFancy } from 'react-icons/fa';
import './css/ProductsSection.css';
import ProductImg from './images/landing.webp';
import { Link } from 'react-router-dom';
import { API_BASE } from '../config/api';
const ProductsSection = () => {
  const defaultSection = useMemo(
    () => ({
      subtitle_text: 'المنتجات الرقمية الأكاديمية (قريبًا)',
      title_text: 'طريقك للتميّز الأكاديمي',
      description_text:
        'نُقدّم مجموعة من المنتجات الرقمية الأكاديمية المصممة خصيصًا لطالبات الدراسات العليا، بهدف دعم رحلتك البحثية وتمكينك من الوصول إلى التميّز الأكاديمي دون الحاجة إلى حجز استشارة مباشرة.\nهذه المنتجات مبنية على خبرة واقعية داخل البيئة الأكاديمية، وتوفّر لك أدوات عملية تساعدك على الفهم، التنظيم، وتجاوز العقبات البحثية بثقة.',
      cta_text: 'عرض كل المنتجات',
    }),
    []
  );

  const [section, setSection] = useState(defaultSection);
  const [products, setProducts] = useState([]);

  const toAbsoluteImageUrl = (maybeUrl) => {
    if (!maybeUrl) return '';
    const u = String(maybeUrl).trim();
    if (!u) return '';
    if (u.startsWith('http://') || u.startsWith('https://')) return u;
    return `${API_BASE}${u}`;
  };

  useEffect(() => {
    let mounted = true;
    Promise.all([
      axios.get(`${API_BASE}/api/products-section`),
      axios.get(`${API_BASE}/api/products?limit=8`),
    ])
      .then(([secRes, prodRes]) => {
        if (!mounted) return;
        const sec = secRes.data?.productsSection;
        const prods = prodRes.data?.products;
        setSection(sec ? { ...defaultSection, ...sec } : defaultSection);
        setProducts(Array.isArray(prods) ? prods : []);
      })
      .catch(() => {
        if (!mounted) return;
        setSection(defaultSection);
        setProducts([]);
      });

    return () => {
      mounted = false;
    };
  }, [defaultSection]);

  return (
    <section className="products-section" id="products" dir="rtl">
      <div className="container">
        
        {/* Header Content from User Text */}
        <div className="text-center mb-5">
          <motion.h6 
            className="section-subtitle"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            {section.subtitle_text}
          </motion.h6>
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            {section.title_text}
          </motion.h2>
          <motion.p 
            className="section-desc"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            {section.description_text}

          </motion.p>
        </div>

        {/* Grid Layout matching Screenshot */}
        <div className="row g-4">
          {products.map((product, index) => (
            <div className="col-lg-3 col-md-6 col-sm-12" key={product.id || product.code}>
              <motion.div 
                className="product-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                {/* Image Area */}
                <div className="card-image-wrapper">
                  <img
                    src={
                      product.image_url
                        ? toAbsoluteImageUrl(product.image_url)
                        : ProductImg
                    }
                    alt={product.title}
                  />
                  <div className="price-badge">{product.price_text || 'قريباً'}</div>
                </div>

                {/* Content Area */}
                <div className="card-body">
                  {/* Meta Data Row */}
                  <div className="card-meta">
                    <div className="meta-item">
                      <FaClock className="meta-icon" />{' '}
                      <span>{product.duration_text || '-'}</span>
                    </div>
                    <div className="meta-item">
                      <FaSignal className="meta-icon" />{' '}
                      <span>{product.level_text || '-'}</span>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="card-title">{product.title}</h3>

                  {/* Divider line implicitly shown in screenshot via spacing */}
                  <div className="card-divider"></div>

                  {/* Category/Action (Optional addition for UX) */}
                  <div className="card-footer-text">
                    {product.category || '-'}
                  </div>
                </div>
              </motion.div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <Link to="/products" className="btn-outline-dark">
            {section.cta_text}
          </Link>
        </div>

      </div>
    </section>
  );
};

export default ProductsSection;